import { render } from "./CategoryIntro.vue?vue&type=template&id=3bdd1f96&scoped=true"
import script from "./CategoryIntro.vue?vue&type=script&lang=js"
export * from "./CategoryIntro.vue?vue&type=script&lang=js"

import "./CategoryIntro.vue?vue&type=style&index=0&id=3bdd1f96&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bdd1f96"]])

export default __exports__